



















import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
const cssPrefix = 'pdfview';

@Component({
  components: {
    ...UUIFComponents,
    SwIcon,
  },
})

export default class PdfviewModal extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  showPdfViewDialog: boolean;
  @Prop()
  pdfUrl : string;
  modifiedPdfUrl : string = '';
  created() {
    this.modifiedPdfUrl = this.pdfUrl;
    console.warn('created');
  }
  closeDialog() {
    this.$emit('closeDialog');
  }
}
